import styled from "styled-components";

export const Container = styled.div`
  width: 90%;
  min-width: 414px;
  max-height: 75vh;
  box-sizing: border-box;

  @media (max-width: 1600px) {
    min-width: 438px;
    min-height: 300px;
    overflow-y: visible;
    overflow-x: hidden;

    overflow-y: auto;
    padding-right: 1rem;
    max-height: 65vh;

    scrollbar-width: thin;
    scrollbar-color: #1d9bf0 transparent;

    &::-webkit-scrollbar {
      width: 6px;
    }

    &::-webkit-scrollbar-thumb {
      background-color: #1d9bf0;
      border-radius: 3px;
    }

    &::-webkit-scrollbar-track {
      background: transparent;
    }
  }
`;

export const TimeContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 0.6rem;
  width: 100%;
  margin-bottom: 10px;
`;
